import { reqGet } from './axiosFun'

/**
 * 订单状态汇总API
 */

// 分页查询订单状态汇总
export function getOrderStatusSummaryPage(params) {
  return reqGet('/erp-order/status-summary/page', params)
}



// WEBPACK FOOTER //
// ./src/api/ErpOrderStatusSummary.js